import React from 'react';
import { panelClass } from '../../governed-mcp-gateway/components/GatewayUi';
import { llmTypeLabel, providerLabel, servingProtocolLabel } from '../llmGatewayConstants';
import type { RegisteredLlm } from '../llmGatewayTypes';

function statusClass(status: RegisteredLlm['status'], isLight: boolean): string {
  if (status === 'active') return isLight ? 'bg-emerald-50 text-emerald-700' : 'bg-emerald-500/15 text-emerald-300';
  if (status === 'draft') return isLight ? 'bg-amber-50 text-amber-700' : 'bg-amber-500/15 text-amber-300';
  return isLight ? 'bg-neutral-100 text-neutral-600' : 'bg-neutral-800 text-neutral-300';
}

export default function ModelInfoCard({ model, isLight }: { model: RegisteredLlm; isLight: boolean }) {
  return (
    <div className={`${panelClass(isLight)} p-4`}>
      <div className="flex items-start justify-between gap-3">
        <div>
          <p className={`text-[11px] font-semibold uppercase tracking-wide ${isLight ? 'text-neutral-400' : 'text-neutral-500'}`}>
            Selected model
          </p>
          <h3 className={`mt-1 text-sm font-semibold ${isLight ? 'text-neutral-900' : 'text-white'}`}>{model.name}</h3>
          <p className={`mt-0.5 text-xs ${isLight ? 'text-neutral-500' : 'text-neutral-400'}`}>
            {providerLabel(model.provider)} · {model.catalog === 'embedding' ? 'Embedding catalog' : 'LLM catalog'}
          </p>
        </div>
        <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-[11px] font-medium capitalize ${statusClass(model.status, isLight)}`}>
          {model.status}
        </span>
      </div>
      <dl className="mt-4 grid grid-cols-2 gap-3 text-xs">
        <div>
          <dt className={isLight ? 'text-neutral-400' : 'text-neutral-500'}>Provider</dt>
          <dd className={`mt-0.5 font-medium ${isLight ? 'text-neutral-800' : 'text-neutral-200'}`}>{providerLabel(model.provider)}</dd>
        </div>
        <div>
          <dt className={isLight ? 'text-neutral-400' : 'text-neutral-500'}>Model type</dt>
          <dd className={`mt-0.5 font-medium ${isLight ? 'text-neutral-800' : 'text-neutral-200'}`}>{llmTypeLabel(model.type)}</dd>
        </div>
        <div>
          <dt className={isLight ? 'text-neutral-400' : 'text-neutral-500'}>Serving protocol</dt>
          <dd className={`mt-0.5 font-medium ${isLight ? 'text-neutral-800' : 'text-neutral-200'}`}>{servingProtocolLabel(model.servingProtocol)}</dd>
        </div>
        <div>
          <dt className={isLight ? 'text-neutral-400' : 'text-neutral-500'}>Capabilities</dt>
          <dd className="mt-1 flex flex-wrap gap-1">
            {model.capabilities.map((capability) => (
              <span
                key={capability}
                className={`px-1.5 py-0.5 rounded-md text-[10px] font-medium ${
                  isLight ? 'bg-indigo-50 text-indigo-700' : 'bg-indigo-500/15 text-indigo-300'
                }`}
              >
                {capability}
              </span>
            ))}
          </dd>
        </div>
      </dl>
    </div>
  );
}
